import { getUserExistingRulebookMode } from "../store/applicationState";
import { RulebookModeEnum, RulebookNameToEnum } from "./rulebook-mode-enum";

export enum DocumentModuleEnum {
    Rulebook = 1,
    Document = 2,
}

export const documentModuleDisplay = (val: DocumentModuleEnum | string | undefined) => {
    let module: DocumentModuleEnum = DocumentModuleEnum.Rulebook;
    const mode = getUserExistingRulebookMode()
    const traditional = RulebookNameToEnum(mode) === RulebookModeEnum.Traditional
    const cbtc = RulebookNameToEnum(mode) === RulebookModeEnum.CBTC

    if (typeof (val) === 'number') {
        module = val;
    }

    if (typeof (val) === 'string') {
        module = parseInt(val);
    }

    switch (module) {
        case DocumentModuleEnum.Rulebook:
            return traditional ? "Rulebook" : cbtc ? "MBS Rulebook" : "";
            break;
        case DocumentModuleEnum.Document:
            return "Rail Document";
            break;
    }

    return "";
}